import styled from "styled-components";

export const StyledFooter = styled.footer`
  
`